<template>
  <div>
    <template v-if="appName === 'FlipPay'">
      <div class="site-logo self-center">
        <img :src="flipLogo" alt="Flippay" />
      </div>
    </template>
    <template v-else-if="appName === 'Rello'">
      <div class="site-logo self-center">
        <img :src="relloLogo" alt="Rello" />
      </div>
    </template>
  </div>
</template>
<script>
export default {
  data() {
    return {
      relloLogo: require('@/assets/images/logo/rello-logo.svg'),
      flipLogo: require('@/assets/images/logo/flippay-logo.svg'),
      appName: process.env.VUE_APP_NAME || "FlipPay",
    };
  },
};
</script>
